import { ENV } from '@shared/config';

import { createService } from './create-service';

export const accessService = createService(ENV.VITE_ACCESS_SERVICE);
